import { render, staticRenderFns } from "./DesignRadio.vue?vue&type=template&id=f44ff6a6&scoped=true&"
import script from "./DesignRadio.vue?vue&type=script&lang=js&"
export * from "./DesignRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44ff6a6",
  null
  
)

export default component.exports